<template>

  <!-- footer ====================================-->
  <footer>
    <div class="footer-wrappper section-img-bg2" style="background-color: aliceblue;">
      <div class="footer-area footer-padding">
        <div class="container">
          <div class="row justify-content-between">
            <div class="ol-lg-4 col-md-4">
              <div class="single-footer-caption">
                <div class="single-footer-caption mb-30">
                  <!-- logo -->
                  <div class="footer-logo mb-25">
                    <router-link to="/"><img :src="$imagens + 'logo.png'" alt=""></router-link>
                  </div>
                  <div v-if="textoRodape != ''" class="footer-tittle">
                    <div class="footer-pera">
                      <p v-html="textoRodape[0].itiResumo1"></p>
                    </div>
                  </div>
                  <!-- social -->
                  <div v-if="redesSociais && redesSociais.length > 0" class="footer-social">

                    <a v-if="redesSociais[0].itiCampoExtra1 !== '0'" :href="redesSociais[0].itiCampoExtra1" target="_blank">
                      <i class="fab fa-facebook"></i>
                    </a>

                    <a v-if="redesSociais[0].itiCampoExtra2 !== '0'" :href="redesSociais[0].itiCampoExtra2" target="_blank">
                      <i class="fab fa-linkedin-in"></i>
                    </a>

                    <a v-if="redesSociais[0].itiNome !== '0'" :href="redesSociais[0].itiNome" target="_blank">
                      <i class="fab fa-youtube"></i>
                    </a>

                    <a v-if="redesSociais[0].itiReferencia !== '0'" :href="redesSociais[0].itiReferencia" target="_blank">
                      <i class="fab fa-instagram"></i>
                    </a>

                  </div>

                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-2">
              <div class="single-footer-caption mb-20">
                <div class="footer-tittle">
                  <h4>Menu</h4>
                  <ul>
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/sobre">Sobre a Empresa</router-link></li>
                    <li><router-link to="/blog">Notícias</router-link></li>
                    <li><router-link to="/contato">Contato</router-link></li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="single-footer-caption mb-20">
                <div class="footer-tittle">
                  <h4>Produtos</h4>
                  <ul v-if="listaProdutos != '' && listaProdutos.length > 0">
                    <li v-for="menu in listaProdutos" :key="menu.itiId">
                      <router-link :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome)">{{
                        menu.itiNome }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="single-footer-caption mb-20">
                <div class="footer-tittle">
                  <h4>Informações Gerais</h4>
                  <ul v-for="menuInfo in informacoes" :key="menuInfo.itiId" class="mb-20">
                    <li><router-link
                        :to="'/informacoes/' + menuInfo.itiId + '/' + menuInfo.itiNome.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">{{
                          menuInfo.itiNome }}</router-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- avance ========================-->
      <div class="footer-bottom-area">
        <div class="container">
          <div class="footer-border">
            <div class="row d-flex align-items-center">
              <div class="col-xl-12 ">
                <div class="footer-copy-right">
                  <a href="https://avancedigital.com.br" target="_blank"><img
                      :src="$imagens + 'avance-digital.png'"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <!-- Scroll Up ======================================-->
  <div id="back-top">
    <a title="Go to Top" href="#"> <i class="fas fa-level-up-alt"></i></a>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageFooter',
  components: {

  },
  data: () => ({
    textoRodape: [],
    redesSociais: [],
    listaProdutos: [],
    informacoes: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
  },

  created() {

    // TEXTO
    axios.get('/Process/InsInstitucional/institucional/10/dadosrodape/0/x')
      .then(response => {
        this.textoRodape = response.data;
        //console.log('textoRodape')
        //console.log(this.textoRodape)
      })
      .catch(error => {
        console.error(error);
      });


    // REDES SOCIAIS
    axios.get('/Process/InsInstitucional/institucional/55/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        //console.log('redesSociais', this.redesSociais);
      })
      .catch(error => {
        console.error(error);
      });

    // INFORMAÇÕES GERAIS
    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('informacoes')
        //console.log(this.informacoes)
      })
      .catch(error => {
        console.error(error);
      });

    // LISTA PRODUTOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaProdutos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaProdutos')
        //console.log(this.listaProdutos)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>